<template>
  <div>
    <form class="builder-form" data-vv-scope="CourseBuilder">
      <!-- <pre>{{filesInfo}}</pre> -->

      <!-- {{equipments}} -->

      <!-- <pre>{{JSON.parse($store.state.navMenuStorage.navMenuItemData)}}</pre>  -->

      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vs-card v-if="editingtrue" class="content_mb_0">
            <h4 style="text-align: center" v-if="editingtrue">
              {{ $route.params.editing_type | capitalize }} Form
            </h4>
            <p class="text-center">(Edit)</p>
          </vs-card>
        </vs-col>
      </vs-row>

      <!-- <pre>{{$route.params.editing_object}}</pre> -->

      <!-- <pre>{{lessons_array}}</pre> -->
      <vs-row v-if="!editingtrue">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vs-card class="cstm-card" style="min-height: 60px">
            <vs-row vs-type="flex" vs-justify="space-around">
              <!-- {{coursetype}} -->
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="2.4"
              >
                <h6 class="tabStyle" @click="courseClicked(courseTab)">
                  Course
                </h6>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="2.4"
              >
                <h6 class="tabStyle" @click="courseClicked(lessonsTab)">
                  Lesson
                </h6>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="2.4"
              >
                <h6 class="tabStyle" @click="courseClicked(topicsTab)">
                  Topic
                </h6>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="2.4"
              >
                <h6 class="tabStyle" @click="courseClicked(settingsTab)">
                  Settings
                </h6>
              </vs-col>
            </vs-row>
            <vs-row vs-type="flex" vs-justify="space-around">
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="2.4"
              >
                <vs-divider v-if="course" color="primary"></vs-divider>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="2.4"
              >
                <vs-divider v-if="lessons" color="primary"></vs-divider>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="2.4"
              >
                <vs-divider v-if="topics" color="primary"></vs-divider>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="2.4"
              >
                <vs-divider v-if="settings" color="primary"></vs-divider>
              </vs-col>
            </vs-row>
            <div slot="footer"></div>
          </vs-card>
        </vs-col>
      </vs-row>

      <vs-tooltip
        v-if="editingtrue && !lessons && !topics"
        color="primary"
        text="Course Settings"
        position="top"
        class=""
        style="position: absolute; z-index: 1; top: 37px; right: 14px"
      >
        <vs-button
          radius
          icon="settings"
          style="background: transparent"
          @click="
            settings = !settings;
            course = !course;
          "
        ></vs-button>
      </vs-tooltip>

      <vs-row v-if="settings">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <settings-component
            @input="getSettingsData"
            :settings_object="settings_object"
            @getAssetsValue="getAssetsValue"
            :assets="assets"
          ></settings-component>
        </vs-col>
      </vs-row>

      <!-- Header Component -->
      <!-- {{course_header}} -->
      <course-builder-header
        v-if="course"
        v-model="course_header"
        :file_repository_id="repository_id"
      ></course-builder-header>

      <!-- Header Component -->

      <!--import Modal -->
      <div v-if="isQuestionModal">
        <vs-popup fullscreen title="" :active.sync="isQuestionModal">
          <question-modal
            :subject_id="subject_ids"
            @closeQuestionBank="closedBank"
          ></question-modal>
        </vs-popup>
      </div>

      <div v-if="isAssignmentModal">
        <vs-popup fullscreen title="" :active.sync="isAssignmentModal">
          <assignment-model
            :course_class_type="settings_object.course_class_type"
            :assignment_type_id="assignment_type_id"
            @getAssignmentData="importedAssignmentData"
            :subject_ids="subject_ids"
            type="course"
          ></assignment-model>
        </vs-popup>
      </div>
      <!-- Import Modal -->
      <!-- Lesson Import -->
      <div v-if="isLessonModal">
        <vs-popup fullscreen title="" :active.sync="isLessonModal">
          <import-lesson-model
            :subject_ids="subject_ids"
            @getLessonLists="importLessonsData"
            type="course"
          ></import-lesson-model>
        </vs-popup>
      </div>
      <!-- Lesson Import -->

      <!-- Tag Component Start  -->
      <vs-row v-if="this.$route.params.editing_object && !settings">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vs-card>
            <TagComponent></TagComponent>
          </vs-card>
        </vs-col>
      </vs-row>
      <!-- Tag component End -->

      <!-- Subject Component -->
      <subject-component
        v-if="!settings"
          :has_all_subject="has_all_subject"
        v-model="subject_id"
        :subjects_added="subjects_added"
        :subjectDisabled="false"
        @allSub='allSub'
      ></subject-component>
      <!-- Subject Component -->

      <!-- Importing Quesion Button -->
      <div class="fixed-import-action">
        <import-module
          v-if="course"
          @openQuestionModal="importQuesionModal"
        ></import-module>
      </div>
      <vs-row v-if="showCourseContent && !settings">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <content-component
           v-model="content.content"
           :file_repository_id="repository_id"
          label="Content"
          ></content-component>
        </vs-col>
      </vs-row>
      <!-- Importing Question Button -->

      <!-- {{content}} -->

      <!-- Lesson Component -->
      <!-- {{lessons_array}} -->
      <!-- <pre>{{ lessons_array }}</pre> -->
      <lesson-component
        v-if="course || lessons"
        v-model="lessons_array"
        :subjects="subject_ids"
        :section_type="currentTab"
        :editingtrue="editingtrue"
        :file_repository_id="repository_id"
      >
      </lesson-component>

      <topic-component
        v-model="topics_array"
        v-if="topics"
        :section_type="currentTab"
        :file_repository_id="repository_id"
      ></topic-component>
      <!-- {{topics}} -->

      
      <file-upload
        v-if="showFileContent && course"
        section_type="CourseComponent"
        :multiplefile="true"
        @getFileId="getIdFile"
        @deletedIndex="deletedIndex"
        :file_repository_id="repository_id"
        :filesInfo="filesInfo"
        ref="fileUploadRef"
      ></file-upload>

      <!-------------- Add More Start -------------->
      <vs-card class="cstm-card" v-if="course">
        <div slot="header">
          <h4>Add More</h4>
        </div>
        <vs-row class="my-4" vs-type="flex" vs-justify="space-around">
          <!-- Add Lesson -->
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="4"
            vs-sm="12"
          >
            <vs-button
              color="primary"
              @click="addNewLesson"
              icon-pack="feather"
              icon="icon-plus-circle"
              type="border"
              v-if="course"
              >Lesson</vs-button
            >
            <!-- {{ lessons }} -->
          </vs-col>

          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="4"
            vs-sm="12"
          >
            <vs-button
              v-if="course"
              color="primary"
              icon-pack="feather"
              icon="icon-plus-circle"
              type="border"
              @click="showCourseContent = !showCourseContent"
              >Content</vs-button
            >
          </vs-col>

          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="4"
            vs-sm="12"
          >
            <vs-button
              v-if="course"
              color="primary"
              icon-pack="feather"
              icon="icon-plus-circle"
              type="border"
              @click="showFileContent = !showFileContent"
              >File</vs-button
            >
          </vs-col>
        </vs-row>
      </vs-card>

      <vs-row v-if="course && imported_question_details.length">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vs-card class="import-vs-card">
            <ImportedQuestionsComponent
              :question_details="imported_question_details"
              @removeImportedQuestionsEvent="removeImportedQuestions"
            >
            </ImportedQuestionsComponent>
          </vs-card>
        </vs-col>
      </vs-row>

      <!-- Assignment Components -->
      <vs-row v-if="imported_assignment_details.length">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vs-card class="import-vs-card">
            <imported-assignments-component
              v-if="course"
              :assignmentDataList="imported_assignment_details"
              @removeImportedAssignmentEvent="removeImportedAssignment"
            >
            </imported-assignments-component>
          </vs-card>
        </vs-col>
      </vs-row>

      <!-- Assignment Components -->
    <!--   <vs-row v-if="filesInfo.length && editingtrue">
        {{file_ids}}

        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <file-showing
            :filesInfo="filesInfo"
            :file_ids="file_ids"
          ></file-showing>
        </vs-col>
      </vs-row> -->

      <vs-row>
        <!-- {{currentTab}} -->
        <!-- {{checkingEdit}} -->
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vs-button
            v-if="!settings"
            color="primary"
            class=""
            type="filled"
            @click.prevent="saveCourseBuilder(currentTab)"
            >{{ checkingEdit }}
            {{
              currentTab === "Lessons"
                ? "lesson"
                : currentTab === "Topics"
                ? "topic"
                : "course"
            }}
          </vs-button>
          <vs-button
            v-if="(settings && !course && !lessons && !topics) || settings"
            color="primary"
            class=""
            type="filled"
            @click.prevent="saveSettings(settings_object)"
          >
            <p v-if="!editingtrue">{{ checkingEdit }} {{ currentTab }}</p>
            <p v-else>Save Settings</p>
          </vs-button>
        </vs-col>
      </vs-row>
     
    </form>
  </div>
</template>


<script>  
import Editor from '@tinymce/tinymce-vue'

import CourseBuilderHeader from './components/CourseBuilderHeader.vue'
import SubjectComponent from './components/SubjectComponent.vue'
import LessonComponent from './components/LessonComponent.vue'
import ImportedQuestionsComponent from './components/ImportedQuestionsComponent.vue'
import ImportedAssignmentsComponent from './components/ImportedAssignmentsComponent.vue'

import TagComponent from './components/TagComponent.vue'
import FileUpload from './components/FileUploadComponent.vue/FileUpload.vue'
import FileShowing from './components/FileUploadComponent.vue/FileShowing.vue'

import ImportModule from './components/Importing/ImportModule.vue'
import QuestionModal from '../questions/question-modal.vue'
import AssignmentModel from './components/Importing/AssignmentModel.vue'
import ImportLessonModel from './components/Importing/ImportLessonModel.vue'

//components
import ContentComponent from '@/components/tinyEditor/ContentComponent.vue'
import TopicComponent from './components/TopicComponent.vue'

//components
import { CourseBuilder } from './mixins/course-builder'

import { EditingMixin } from './mixins/EditingMixin'
import { SettingsMixin } from './mixins/SettingsMixin'

import { Testing } from './mixins/testing-mixin'
import vSelect from 'vue-select'

import SettingsComponent from './components/SettingsComponent.vue'

export default {
  name: 'course-builder',
  mixins: [
    CourseBuilder,
    Testing,
    EditingMixin,
    SettingsMixin
  ],
  components: {
    editor: Editor,
    CourseBuilderHeader,
    ContentComponent,
    TopicComponent,
    SubjectComponent,
    LessonComponent,
    ImportedQuestionsComponent,
    ImportedAssignmentsComponent,
    TagComponent,
    QuestionModal,
    vSelect,
    FileUpload,
    ImportModule,
    AssignmentModel,
    ImportLessonModel,
    FileShowing,
    SettingsComponent
    // ImportBrowserFilesModel
  },

  created () {
    
    if (this.$route.params.type) {
      this.custom =
        this.$route.params.courseApplicationType === 'General' ? 0 : 1
      this.courseClicked(this.$route.params.type)
    }
    //Setting course builder header course_header (obj)
    this.course_header.editingtrue = this.editingtrue
    if (this.editingtrue === false) {
      //Getting settings_obj from SettingsMixin assigning to local object on new create
      this.settings_object = this.settings_obj
    } else {
      this.settings_object = this.$route.params.editing_object.courseSetting
    }
  },
  mounted () {
   
  },
  filters: {
    capitalize (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  data () {
    return {
      has_all_subject:true,
      subject_id: [],
      activeConfirm: false,
      settings_object: '',
      showImportedQuestions: false,
      question_details: [],
      isQuestionModal: false,
      imported_assignment_details: [],
      isBrowseContent:false,
      isAssignmentModal: false,
      isLessonModal: false,
      isLessonDetailsData: [],
      assignment_id: '', //2 homework, 4 exams, 3 reports etc
      texteditor: '',
      profilePic: null,
      course: true,
      topics: false,
      lessons: false,
      settings: false,
      courseTab: 'course',
      lessonsTab: 'lessons',
      topicsTab: 'topics',
      settingsTab: 'settings',
      currentTab: 'course',
      courseTitle: '',
      custom: 0
    }
  },

  methods: {    
    allSub(data){
      console.log(data)
      this.has_all_subject = data
    },
    saveSettings (settings_object) {


      
      
      //Getting settings_object from SettingsMixin

      // const checkingTime = this.checkingStartEndTiming(settings_object)
      const checkingTime = true
      
      if (!checkingTime) {
        this.showSuccessMessage(
          'Error',
          'Start Time must be less than end timing',
          'warning'
        )
      } else {
        
        if(!this.settings_object.class_duration && this.settings_obj.course_class_type =='online_one_2_one'){
          if(this.settings_object.session_frequency>0){
             this.$vs.notify({
          title: 'Warning',
          text: 'Please provide a class duration',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
          time: 3000
        })
          } else {
            this.settings_object = settings_object
             this.$vs.notify({
          title: 'success',
          text: 'Settings attatched successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })
        this.course = true
        this.currentTab = 'course'
        this.settings = false
          }

        }else {
           this.settings_object = settings_object
             this.$vs.notify({
          title: 'success',
          text: 'Settings attatched successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })
        this.course = true
        this.currentTab = 'course'
        this.settings = false
        }
       
      }
    },
    getAssetsValue (payload) {
      
      
      this.$emit('getAssetsValue', payload)
      this.assets = [...payload]
      
      
    },
    getSettingsData (settings_object) {
      this.settings_object = settings_object
    },
    validationcheck () {
      
      this.$validator.validateAll().then((valid) => {
        
      })
    },

    courseClicked (typeOftab) {
      if (typeOftab === 'lessons') {
        this.lessons = true
        this.topics = false
        this.settings = false
        this.course = false
        this.currentTab = 'Lessons'
        this.lessons_array.length = 0
        if (!this.$route.params.editing_object) {
          this.lessons_array.push({
            // courseTitle: '',
            // courseDescription: ''

            name: '',
            description: '',
            subject_ids: [],
            assignment_ids: [],
            file_ids: [],
            question_ids: [],
            topics: [],
            content: {
              content: ''
            },
            showCourseContent: false,
            showFileContent: false,
            isCollapseCard: false,
            imported_assignment_details: [],
            imported_question_details: []
          })
        }
      } else if (typeOftab === 'topics') {
        console.log('Hi')
        this.lessons = false
        this.topics = true
        this.settings = false
        this.course = false
        this.currentTab = 'Topics'
        
        this.topics_array.length = 0
        if (!this.$route.params.editing_object) {
          this.topics_array.push({
            name: '',
            description: '',
            subject_ids: [],
            assignment_ids: [],
            question_ids: [],
            content: {
              content: ''
            },
            file_ids: [],
            showCourseContent: false,
            showFileContent: false,
            isCollapseCard: false,
            filesInfo: []
          })
        }
      } else if (typeOftab === 'settings') {
        this.lessons = false
        this.topics = false
        this.settings = true
        this.course = false
        this.currentTab = 'Settings'
      } else {
        this.lessons = false
        this.topics = false
        this.settings = false
        this.course = true
        this.currentTab = 'course'
      }
    },

    addNewLesson () {
      
      // this.lessons_array.length = 0
      this.lessons_array.push({
        // courseTitle: '',
        // courseDescription: ''

        name: '',
        description: '',
        subject_ids: [],
        assignment_ids: [],
        file_ids: [],
        question_ids: [],
        topics: [],
        content: {
          content: ''
        },
        showCourseContent: false,
        showFileContent: false,
        isCollapseCard: false,
        filesInfo: [],
        imported_assignment_details: [],
        imported_question_details: [],
        imported_assignment_details_added_info: [],
        imported_question_details_added_info: [],
        is_imported: false,
        is_visible: false
      })
    },

    removeCard (index) {
      this.addCourseData.splice(index, 1)
    },

    addTopic () {
      this.topics.push({
        name: '',
        description: '',
        subject_ids: [],
        assignment_type_id: [],
        question_ids: [],
        content: {
          content: ''
        },
        file_ids: [],
        is_imported: false
      })
    },
    removeTopic (index) {
      this.addTopicData.splice(index, 1)
    },
    getIdFile (obj) {
      
      if (Array.isArray(obj)) {
        this.file_ids = [...this.file_ids, ...obj]
      } else {
        this.file_ids.push(obj)

      }
    },
    deletedIndex (deleteIndex) {
      this.file_ids.splice(deleteIndex, 1)
      this.filesInfo.splice(deleteIndex, 1)
    },

    closedBank (importedQuestionObject) {
      
      // 
      const newQuestionArray = importedQuestionObject.map((ele) => {
        return {
          id: null,
          questions: {
            id: ele.id,
            title: ele.question_title,
            subject: ele.subject,
            input_type_id_obj: ele.input_type_id_obj,
            files: ele.file,
            links: ele.links,
            questions_options: ele.option,
            questions_answers: ele.answers,
            point: ele.point,
            feedback: ele.answerfeedback
          }
        }
      })
      

      this.imported_question_details.push(...newQuestionArray)

      

      this.question_ids = this.imported_question_details.map((ele) => {
        return ele.questions.id
      })

      // this.isQuestionModal = false
      setTimeout(() => {
        this.isQuestionModal = false
      }, 1000)
    },
    importQuesionModal (obj) {
      if (this.subject_ids.length > 0) {
        
        if (obj.name === 'isQuestionModal') {
          this.isQuestionModal = true
        } else if (obj.name === 'isLessonModal') {
          this.isLessonModal = true
        } else {
          this.isAssignmentModal = true
          this.assignment_type_id = obj.id
        }
      } else {
        
        this.showSuccessMessage(
          'Warning',
          'You must select atleast 1 subject',
          'warning'
        ) //title,success_text, color
      }
    },
    importedAssignmentData (singleAssignmentObject) {
      singleAssignmentObject.forEach((ele) => {
        this.imported_assignment_details.push({
          id: null,
          assignment: {
            id: ele.id,
            assignment_type_obj: ele.assignment_type_obj,
            subject: ele.subject,
            questions: ele.questions,
            title: ele.title,
            description: ele.description
          },
          status: true
        })
      })
      // this.imported_assignment_details.push(...obj)
      this.assignment_ids = this.imported_assignment_details.map((ele) => {
        return ele.assignment.id
      })
      setTimeout(() => {
        this.isAssignmentModal = false
      }, 1000)
      // this.isAssignmentModal = false
      // 
    },
    importLessonsData (importedLessonObject) {
      
      importedLessonObject.forEach((editing_object) => {
        
        this.lessons_array.push({
          id: editing_object.id,
          name: editing_object.name,
          description: editing_object.description,
          subject_ids: [],
          assignment_ids: [],
          file_ids: [],
          question_ids: this.getQuestionIds(editing_object.lessonQuestions),
          content: editing_object.lessonContent,
          showCourseContent: true,
          showFileContent: false,
          isCollapseCard: false,
          filesInfo: editing_object.lessonFiles,
          imported_question_details: editing_object.lessonQuestions,
          imported_assignment_details: editing_object.lessonAssignments,
          imported_assignment_details_added_info:
            editing_object.lessonAssignments,
          imported_question_details_added_info: editing_object.lessonQuestions,
          is_imported: true,
          topics: editing_object.lessonTopics.map((ele) => {
            
            return {
              id: ele.topic.id,
              name: ele.topic.name,
              description: ele.topic.description,
              subject_ids: [],
              assignment_ids: [],
              question_ids: [],
              content: {
                id: ele.topic.topic_content.id
                  ? ele.topic.topic_content.id
                  : null,
                content: ele.topic.topic_content.content
                  ? ele.topic.topic_content.content
                  : ''
              },
              file_ids: [],
              showCourseContent: false,
              showFileContent: false,
              isCollapseCard: false,
              filesInfo: ele.topic.topic_files,
              is_imported: true
            }
          })
        })
      })

      setTimeout(() => {
        this.isLessonModal = false
      }, 1000)
    }
  }
}
</script>
<style lang="stylus">
.tabStyle {
  cursor: pointer;
}

.select_custom {
  height: 40px;
  border: none;
  background-color: white;
  border: 1px solid #cccccc;
  color: #787878;
  font-size: 14px;
  width: 100%;
  border-radius: 5px;
}

img {
  max-width: 100%;
}

video {
  max-width: 100%;
}

.builder-form {
  max-width: 66.67%;
  margin: 0 auto;
  position: relative;
  padding: 20px 0;
}

.fixed-import-action {
  position: absolute;
  right: -75px;
  bottom: 40px;
}

.import-btn .con-vs-tooltip:not(:last-child) .import_icon_holder {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  margin: 5px 0;
}

.import-vs-card .vs-card--content {
  margin-bottom: 0;
}

@media (max-width: 1200px) {
  .builder-form {
    max-width: 90%;
  }
}

@media (max-width: 568px) {
  .fixed-import-action {
    right: 14%;
    transform: rotate(-90deg);
    bottom: -15px;
  }

  .import-vs-card {
    margin-bottom: 70px;
  }

  .import_icon_holder {
    transform: rotate(90deg);
  }

  .import-btn .con-vs-tooltip:not(:last-child) .import_icon_holder {
    border-bottom: none;
    padding-right: 5px;
    border-right: 1px solid rgba(0, 0, 0, 0.1);
  }
}
</style>